var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LandPage"},[_c('div',{staticClass:"card"},[_c('b',[_vm._v("Total Control Desktop")]),_c('img',{staticClass:"brand-logo",attrs:{"src":_vm.whitelabel.brand_logo,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }